/* Orlivia — zone produit
   Flèches, points et légende de la galerie ; pilules défilantes ; icônes SVG
   recolorées. Le carrousel reste celui du thème (Flickity) : on ne le remplace
   pas, on lui envoie l'événement « theme:image:change » qu'il écoute déjà, et
   on lit l'image affichée sur la classe « is-selected » qu'il pose lui-même. */
(function () {
  'use strict';

  if (window.__orliviaProduct) return;
  window.__orliviaProduct = true;

  /* ------------------------------------------------------------ galerie */

  function visibleSlides(slideshow) {
    var all = slideshow.querySelectorAll('[data-media-slide]');
    var out = [];
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.classList.contains('hide') || el.hasAttribute('hidden')) continue;
      if (!el.getAttribute('data-media-id')) continue;
      out.push(el);
    }
    return out;
  }

  function currentIndex(slides) {
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('is-selected')) return i;
    }
    return 0;
  }

  function selectMedia(slideshow, id) {
    slideshow.dispatchEvent(new CustomEvent('theme:image:change', { detail: { id: id } }));
  }

  function Gallery(root) {
    this.root = root;
    this.slideshow = root.querySelector('[data-product-slideshow]');
    if (!this.slideshow) return;
    this.dots = root.querySelector('[data-oi-gnav-dots]');
    this.caption = root.querySelector('[data-oi-caption]');
    this.bind();
    this.buildDots();
    this.sync();
    this.placeArrows();
    this.watch();
  }

  Gallery.prototype.bind = function () {
    var self = this;
    var arrows = this.root.querySelectorAll('[data-oi-gnav]');
    for (var i = 0; i < arrows.length; i++) {
      arrows[i].addEventListener('click', function (event) {
        event.preventDefault();
        var dir = this.getAttribute('data-oi-gnav') === 'prev' ? -1 : 1;
        var slides = visibleSlides(self.slideshow);
        if (slides.length < 2) return;
        var next = (currentIndex(slides) + dir + slides.length) % slides.length;
        selectMedia(self.slideshow, slides[next].getAttribute('data-media-id'));
      });
    }
  };

  Gallery.prototype.buildDots = function () {
    if (!this.dots) return;
    var self = this;
    var slides = visibleSlides(this.slideshow);
    var style = this.dots.getAttribute('data-oi-dot-style') || 'dot';
    this.dots.innerHTML = '';
    if (slides.length < 2) return;
    for (var i = 0; i < slides.length; i++) {
      var id = slides[i].getAttribute('data-media-id');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'oi-gnav__dot';
      b.setAttribute('data-oi-dot-for', id);
      b.setAttribute('aria-label', 'Image ' + (i + 1));
      if (style === 'number') b.textContent = String(i + 1);
      b.addEventListener('click', function () {
        selectMedia(self.slideshow, this.getAttribute('data-oi-dot-for'));
      });
      this.dots.appendChild(b);
    }
  };

  Gallery.prototype.sync = function () {
    var slides = visibleSlides(this.slideshow);
    if (!slides.length) return;
    var id = slides[currentIndex(slides)].getAttribute('data-media-id');

    if (this.dots) {
      var dots = this.dots.querySelectorAll('[data-oi-dot-for]');
      for (var i = 0; i < dots.length; i++) {
        dots[i].setAttribute('aria-current', dots[i].getAttribute('data-oi-dot-for') === id ? 'true' : 'false');
      }
    }

    if (this.caption) {
      var items = this.caption.querySelectorAll('[data-oi-cap-for]');
      for (var j = 0; j < items.length; j++) {
        items[j].classList.toggle('is-on', items[j].getAttribute('data-oi-cap-for') === id);
      }
    }
  };

  // Les flèches sont posées sur le cadre de la galerie, qui contient aussi les
  // vignettes : on les centre sur les images seules, pas sur l'ensemble.
  Gallery.prototype.placeArrows = function () {
    var grid = this.slideshow;
    if (!grid || !grid.offsetHeight) return;
    var top = grid.offsetTop + grid.offsetHeight / 2;
    this.root.style.setProperty('--OI-GNAV-TOP', Math.round(top) + 'px');
  };

  Gallery.prototype.watch = function () {
    var self = this;
    var pending = null;
    function soon() {
      if (pending) window.clearTimeout(pending);
      pending = window.setTimeout(function () {
        pending = null;
        self.sync();
        self.placeArrows();
      }, 60);
    }
    new MutationObserver(soon).observe(this.slideshow, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () {
        self.placeArrows();
      });
      ro.observe(this.slideshow);
    }
    window.addEventListener('resize', soon);
    // le thème peut reconstruire les diapositives au changement de variante
    this.slideshow.addEventListener('theme:image:change', soon);
  };

  /* ------------------------------------------------- icônes SVG à recolorer */

  /* Une icône SVG importée peut être recolorée sans que le marchand ait à
     connaître ses couleurs d'origine : on relève les couleurs présentes dans
     l'ordre où elles apparaissent, et on remplace la 1re, la 2e, la 3e par
     celles choisies dans le thème. */
  function recolorSvg(host) {
    var slots = (host.getAttribute('data-oi-svg-colors') || '').split('|');
    var svg = host.querySelector('svg');
    if (!svg || !slots.length) return;

    var found = [];
    var nodes = svg.querySelectorAll('*');
    var props = ['fill', 'stroke', 'stop-color'];

    function noteColor(value) {
      if (!value) return;
      value = value.trim().toLowerCase();
      if (!value || value === 'none' || value === 'transparent' || value === 'currentcolor') return;
      if (found.indexOf(value) === -1) found.push(value);
    }

    for (var i = 0; i < nodes.length; i++) {
      for (var p = 0; p < props.length; p++) {
        noteColor(nodes[i].getAttribute(props[p]));
        var style = nodes[i].style;
        if (style && style[props[p]]) noteColor(style[props[p]]);
      }
    }
    // un SVG sans couleur déclarée est noir par défaut : on lui donne un slot
    if (!found.length) found.push('__default__');

    for (var n = 0; n < nodes.length; n++) {
      for (var q = 0; q < props.length; q++) {
        var node = nodes[n];
        var attr = props[q];
        var cur = (node.getAttribute(attr) || '').trim().toLowerCase();
        var target = null;
        if (cur && cur !== 'none' && cur !== 'transparent') {
          target = found.indexOf(cur);
        } else if (!cur && attr === 'fill' && found[0] === '__default__') {
          target = 0;
        }
        if (target === null || target < 0) continue;
        var color = slots[target];
        if (!color) continue;
        node.setAttribute(attr, color);
        if (node.style && node.style[attr]) node.style[attr] = color;
      }
    }
    svg.removeAttribute('width');
    svg.removeAttribute('height');
  }

  function initSvgHosts(scope) {
    var hosts = (scope || document).querySelectorAll('[data-oi-svg-colors]:not([data-oi-svg-done])');
    for (var i = 0; i < hosts.length; i++) {
      hosts[i].setAttribute('data-oi-svg-done', '');
      recolorSvg(hosts[i]);
    }
  }

  /* --------------------------------------------------- pilules défilantes */

  /* Le ruban ne défile que s'il déborde : sinon les pilules restent tranquilles,
     centrées, et on évite un mouvement inutile sur une seule pilule. */
  function initMarquee(scope) {
    var rails = (scope || document).querySelectorAll('[data-oi-marquee]:not([data-oi-marquee-done])');
    for (var i = 0; i < rails.length; i++) {
      (function (rail) {
        rail.setAttribute('data-oi-marquee-done', '');
        var track = rail.querySelector('[data-oi-marquee-track]');
        if (!track) return;

        function apply() {
          var overflows = track.scrollWidth > rail.clientWidth + 2;
          rail.classList.toggle('is-scrolling', overflows);
          if (!overflows) {
            track.style.removeProperty('--OI-MARQUEE-DURATION');
            return;
          }
          if (!rail.hasAttribute('data-oi-marquee-cloned')) {
            rail.setAttribute('data-oi-marquee-cloned', '');
            var copy = track.cloneNode(true);
            copy.setAttribute('aria-hidden', 'true');
            copy.removeAttribute('data-oi-marquee-track');
            track.parentNode.appendChild(copy);
          }
          var speed = parseFloat(rail.getAttribute('data-oi-marquee-speed')) || 40; // px/s
          var duration = track.scrollWidth / speed;
          rail.style.setProperty('--OI-MARQUEE-DURATION', duration.toFixed(2) + 's');
        }

        apply();
        if (window.ResizeObserver) new ResizeObserver(apply).observe(rail);
        window.addEventListener('resize', apply);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(apply);
      })(rails[i]);
    }
  }

  /* ------------------------------------------------------------- démarrage */

  function initIn(scope) {
    var galleries = (scope || document).querySelectorAll('[data-oi-gallery]:not([data-oi-gallery-done])');
    for (var i = 0; i < galleries.length; i++) {
      galleries[i].setAttribute('data-oi-gallery-done', '');
      new Gallery(galleries[i]);
    }
    initSvgHosts(scope);
    initMarquee(scope);
  }

  function boot() {
    initIn(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initIn(event.target);
  });
})();
